
import Vue from "vue";

export interface ActionButtonProps {
  text: string;
}

export default Vue.extend({
  name: "ActionButton",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick(): void {
      this.$emit("click", this.text);
    },
  },
});
